import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Status } from 'client/voladeum/statuses/types';
import { SLICE } from 'ducks/slice';

import { EMPTY_ARRAY } from '../../constants';

const initialState: Status[] = EMPTY_ARRAY;

export const statusesSlice = createSlice({
  name: SLICE.STATUSES,
  initialState,
  reducers: {
    setStatuses: (_state, action: PayloadAction<Status[]>) => {
      return action.payload;
    },
    clearStatus: () => {
      return initialState;
    },
  },
});

export const { setStatuses, clearStatus } = statusesSlice.actions;

export default statusesSlice.reducer;
